import React, { useCallback, useEffect, useMemo, useRef } from "react";
import Vimeo from "@u-wave/react-vimeo";
import { attachVimeoPlaybackGuards, getVimeoStartupQuality } from "../../utils/vimeoPlayback";

/**
 * Drop-in Vimeo player that caps startup quality on mobile/cellular
 * and recovers from AT&T-style first-play buffer stalls.
 */
export default function VimeoPlayer({ onReady, quality, playsInline = true, ...props }) {
    const detachRef = useRef(null);
    const startupQuality = useMemo(
        () => (quality !== undefined ? quality : getVimeoStartupQuality()),
        [quality]
    );

    useEffect(() => () => {
        detachRef.current?.();
        detachRef.current = null;
    }, []);

    const handleReady = useCallback((player) => {
        detachRef.current?.();
        detachRef.current = attachVimeoPlaybackGuards(player, {
            preferredQuality: startupQuality,
        });
        if (onReady) onReady(player);
    }, [onReady, startupQuality]);

    return (
        <Vimeo
            playsInline={playsInline}
            {...props}
            quality={startupQuality}
            onReady={handleReady}
        />
    );
}
